import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        title: $setup.t('cart'),
        parentPath: "/products"
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  ($setup.cartItems && $setup.cartItems.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartItems, (item) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: item.productId
                              }, {
                                default: _withCtx(() => [
                                  (item.photoLink)
                                    ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                        key: 0,
                                        slot: "start",
                                        "router-link": `/products/${item.productId}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: $setup.addResizeUrlParams(item.photoLink, 300)
                                          }, null, 8, _hoisted_3)
                                        ]),
                                        _: 2
                                      }, 1032, ["router-link"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, [
                                        _createElementVNode("b", null, [
                                          _createTextVNode(_toDisplayString($setup.getLocalizedStr(item, 'title', 'titleEn')), 1),
                                          (item.coralId)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(item.coralId) + ")", 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_5
                                      ]),
                                      _createElementVNode("p", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(Number(item.sellingPrice * item.quantity).toLocaleString()), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        slot: "icon-only",
                                        onClick: ($event: any) => ($setup.removeCartItem(item))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: $setup.trash }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString($setup.t('CartPage.orderTotal')) + "HK$" + _toDisplayString($setup.getCartTotal().toLocaleString()), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          fill: "outline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openCheckoutModal()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('CartPage.checkout')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('CartPage.emptyCart')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          "router-link": "/products"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('CartPage.shopNow')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}